import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Page, PageHeader } from '../components/common'
import { Config } from '../config/config';
import { AuthContext, InitialAuthContext } from '../context/auth';
import { Account } from '../types/types';
import { LiveList } from '../components/livestreamList';

function LiveStreams() {
  
  const {authenticated, setAuthenticated} = useContext(AuthContext)

  const [accounts, setAccounts] = useState([] as Account[])

  const loadAccounts = useCallback(async () => {
    // /admin/accounts is superadmin-only; regular users only see their own accounts
    if (!authenticated.isSuperadmin) {
      setAccounts(authenticated.availableAccounts.map(id => ({id, name: {String: id, Valid: true}} as Account)))
      return
    }

    let res = await fetch(
      `${Config.base_url}/api/v1/admin/accounts`,
      {
        headers: {
          Authorization: "Bearer " + authenticated.token,
        },
      }
    );
    if (res.status !== 200) {
      if (res.status === 401) {
        setAuthenticated(InitialAuthContext.authenticated);
      }
      return;
    }
    let resJson = await res.json();
    if (resJson.ok) setAccounts((resJson.accounts as Account[]).sort((a,b)=>a.id<b.id? -1: 1));
  }, [authenticated, setAuthenticated])

  useEffect(()=>{
    loadAccounts()
  }, [loadAccounts])
  return (
    <Page>
      <PageHeader>Live Streams</PageHeader>
      <LiveList accounts={accounts}/>
    </Page>
  )
}

export default LiveStreams